import { URL_LABEL } from "../../../../../content/index.content";

const productKeywordsLookup = ({ language, isSavedUser }) => {
  return {
    title: "Product Keywords Lookup 2.0",
    href: isSavedUser
      ? `/app/#/product-keywords/?${URL_LABEL}`
      : `/reverse-asin-lookup/?${URL_LABEL}`,
    subtitle:
      "Gather new keyword ideas from competitor pages and improve your own product listings",
    isLink: !isSavedUser,
  };
};

export default productKeywordsLookup;
